module.exports = __webpack_public_path__ + "img/waf-vps.fcecd73 1.a325d41.svg";